import { _addJaDict } from "app/i18n/i18n";

_addJaDict({
  comment: "*** Resdesign translations",
  // top menu bar
  "All Periodicals": "定期刊行物すべて",
  "All Categories": "カテゴリすべて",
  "All Sectors": "セクターすべて",

  // side filter bar
  Category: "カテゴリ",
  Sector: "セクター",
  "Industry Group": "産業グループ",
  "Research Team": "リサーチチーム",
  Close: "閉じる",
  Theme: "テーマ / トピック",
  "Price/Rating": "レーティング/目標株価",
  Format: "フォーマット",
  Date_2: "日付",

  // top links bar
  Coverage: "カバレッジ",
  Analysts: "アナリストディレクトリ",
  "Custom range": "日付範囲指定",
});
